<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10zKyZJ/tc-custom/9781504089982.jpg?1728259422581" alt="This image is the cover for the book Parting of the Ways"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Parting of the Ways
      </h1>
      <p class="bookDescription body article font2">
        <b>An “intelligently written and thought-provoking” novel of two women, an abandoned baby, a long-ago trauma, and a confrontation with truth (<i>Cambridge Journal</i>).</b><br/><br/> When they were nineteen, taking a summer journey along the British coast, Olivia and Eve found a newborn baby in a phone box.<br/><br/> The trip had been filled with adventures, arguments, and friendship. But that day marked the end of it all. The baby could have drawn them together, but instead, the trauma of its story pushed them dramatically apart. A few days later, Olivia and Eve went their separate ways and never spoke to each other again.<br/><br/> Twenty-five years later, their lives have gone in very different directions. But when a mutual friend writes to tell Olivia she’s getting married, Olivia knows the moment is coming when she and Eve will have to see each other again—and face the truth of what happened that summer, and what it has done to them . . .<br/><br/> “Witty and empathetic.” —<i>Country Life</i><br/><br/><b>Praise for <i>The Things You Do for Love</i></b><br/><br/> “A wonderful page-turner of a novel.” —Fay Weldon, award-winning author of <i>Habits of the House </i>and <i>Big Girls Don’t Cry</i><br/><br/> “The very best sort of fiction.” —Juliet Nicolson, author of <i>A House Full of Daughters</i> and <i>The Perfect Summer</i><br/><br/> “A richly textured tale of life and love.” —Richard Mason, award-winning author of <i>Who Killed Piet Barol?</i><br/><br/><i>An earlier version of this novel was published in 2011 by Hookline Books as </i>The Partridge and the Pelican
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rachel Crowther
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ca674f9